import { Component, Input } from '@angular/core'
import { UntypedFormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms'
import { environment } from '../../../../environments/environment.prod'
import { ActivatedRoute } from '@angular/router'
import { DropDownListComponent } from '@progress/kendo-angular-dropdowns';
@Component({
    selector: 'gd-rvdropdown',
    template: `
    <div [formGroup]="form">
      <kendo-dropdownlist
        [formControlName]="field.name"
        [id]="field.name"
        (selectionChange)="selectionChanger($event)"
        style="width: 350px;"
        [data]="field.options"
        [valueField]="'key'"
        [textField]="'label'"
        [valuePrimitive]="true"
      >
      </kendo-dropdownlist>
    </div>
  `,
    imports: [
        FormsModule,
        ReactiveFormsModule,
        DropDownListComponent,
    ]
})
export class RvDropDownComponent {
  @Input() field: any = {}
  @Input() form: UntypedFormGroup
  public validinfo: boolean
  public rowStatus = false
  public warningStatus = false
  public warnmsg = environment.warningSurrender
  public showViewhistorybtn: boolean
  private unsavedCustomAlertText = ''

  constructor(
    /* private metamsg: MiddleService, */ private route: ActivatedRoute,
  ) {
    this.validinfo = false
    this.rowStatus = false
    this.onloadchanges()
  }
  public openmodel() {
    //  this.metamsg.changeBool(true);
  }
  selectionChanger(event: { key: string }) {
    if (event.key !== 'CUSTOM') {
      this.unsavedCustomAlertText = this.form.get('AlertRepText').value
    }

    if (event.key === 'NIGO') {
      this.form.get('AlertRepText').setValue('')
      this.form.get('AlertRepText').setValue(environment.alertreptxt)
    }
    if (event.key === 'PENDING ALERT') {
      this.form.get('AlertRepText').setValue(environment.alertpendingtxt)
    }
    if (event.key === 'CUSTOM') {
      if (this.unsavedCustomAlertText !== '') {
        this.form.get('AlertRepText').setValue(this.unsavedCustomAlertText)
      } else {
        this.form.get('AlertRepText').setValue('')
      }
    }
    if (event.key === 'Missing') {
      this.validinfo = true
    } else {
      this.validinfo = false
    }
    if (this.field.value.mutualFundClass) {
      this.warnmsg = environment.warningSurrender
    }
  }

  onloadchanges() {
    this.showViewhistorybtn = false
    if (this.route.snapshot.queryParams['Rview']) {
      this.route.queryParams.subscribe((params) => {
        this.showViewhistorybtn = true
      })
    }
  }
}
